module.exports = __webpack_public_path__ + "1792395595471/fonts/line-awesome.452a5b4.woff2";